import instance from './instance';

export const updateOrganization = data => instance.put(`/organization`, data);

export const getBillingData = () => instance.get(`/organization/billing_data`);

export const updateOrganizationData = params => instance.put(`/organization/update_data`, params);
